import React, { useContext } from "react";
import "./Blog.scss";
import BlogCard from "../../components/blogCard/BlogCard";
import { blogSection } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Blogs() {
  const { isDark } = useContext(StyleContext);

  if (!blogSection.display) {
    return null;
  }

  return (
    <section className={`section ${isDark ? "dark-mode" : ""}`} id="blogs">
      <div className="container">
        <div className="blog-header">
          <p className="typography-eyebrow mb-2">My Thoughts</p>
          <h2 className="section-title mb-3">{blogSection.title}</h2>
          <p className="section-subtitle mb-5">
            {blogSection.subtitle}
          </p>
        </div>
        <div className="blog-text-div">
          {blogSection.blogs.map((blog, i) => (
            <BlogCard
              key={i}
              isDark={isDark}
              blog={{
                url: blog.url,
                title: blog.title,
                description: blog.description
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
